import React, { useEffect } from 'react';
import cn from 'classnames';
import Form, { useForm } from 'components/Form';
import {
  Title,
  SectionWrapper,
} from 'views/pages/ClientDetail/components/Elements';
import ButtonActions from 'views/pages/ClientDetail/components/ButtonActions';
import OnlinePortal from 'views/pages/ClientDetail/components/OnlinePortal';
import Profile from './Profile';
import Permit from './Permit';
import { getInitialValues, newYorkTransformData } from '../../tabUtils/newYork';
import classes from './NewYork.module.scss';

const NewYork = ({
  className,
  wrapperId,
  handleSubmit,
  isEdit,
  setIsEdit,
  isFormChange,
  loading,
  openWarningModal,
  data,
  setIsFormChanged,
  onFormChange,
  years,
  handleYearSubmit,
}) => {
  const transformData = newYorkTransformData(
    data,
    process.env.REACT_APP_NEW_YORK_HUT_PL,
    process.env.REACT_APP_NEW_YORK_OSCAR_PL
  );
  const [form] = useForm();
  const initialValues = getInitialValues(data);

  useEffect(() => {
    if (isEdit) {
      setIsFormChanged(false);
      if (form) {
        form.resetFields();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit]);

  return (
    <SectionWrapper className={cn(classes.wrapper, className)} id={wrapperId}>
      <Form
        validateMessages={''}
        onFinish={values => {
          handleSubmit(values, form);
        }}
        initialValues={initialValues}
        form={form}
        onValuesChange={() => {
          setIsFormChanged(true);
          onFormChange();
        }}
      >
        <div>
          <Title text="New York HUT Permit ">
            <ButtonActions
              setIsEdit={setIsEdit}
              isEdit={isEdit}
              form={form}
              isFormChanged={isFormChange}
              loading={loading}
              className={classes.buttonActions}
              onSubmit={values => {
                handleSubmit(values, form);
              }}
              openWarningModal={openWarningModal}
            />
          </Title>
          <Profile isEdit={isEdit} form={form} data={transformData} />
          <OnlinePortal
            title="NY HUT Online Portal"
            stateName="hut_state_id"
            portalLinkName="hut_portal_link"
            form={form}
            isEdit={isEdit}
            portalLinkReadOnly
            data={transformData}
            fields={[
              {
                name: 'hut_username',
                label: 'Username',
                type: 'value',
                key: 'hut_username',
              },
              {
                name: 'hut_password',
                label: 'Password',
                type: 'value',
                key: 'hut_password',
              },
            ]}
          />
        </div>
        <div>
          <OnlinePortal
            title="Oscar Online Portal"
            stateName="oscar_state_id"
            portalLinkName="oscar_portal_link"
            form={form}
            isEdit={isEdit}
            portalLinkReadOnly
            data={transformData}
            fields={[
              {
                name: 'oscar_username',
                label: 'Username',
                type: 'value',
                key: 'oscar_username',
              },
              {
                name: 'oscar_password',
                label: 'Password',
                type: 'value',
                key: 'oscar_password',
              },
            ]}
          />
        </div>
        <Permit
          form={form}
          data={transformData}
          years={years}
          handleYearSubmit={handleYearSubmit}
          initialValues={initialValues}
        />
      </Form>
    </SectionWrapper>
  );
};

export default NewYork;
